import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "./index.scss";
import ProductPageSubtitlesTabContent from "./ProductPageSubtitlesTabContent";
import SdrPageSubtitlesTabContent from "./SdrPageSubtitlesTabContent";
import CyberSecuritySubTitlesTabContent from "./CyberSecuritySubTitlesTabContent";

const ProductPageSubtitlesTab = () => {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <div className="user__tabs__container mt-7">
      <Tabs
        className="user__tab__container"
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
      >
        <TabList className="user__tab__list__section">
          <Tab className="user__single__tab ">Product Manager</Tab>
          <Tab className="user__single__tab mll">SDR</Tab>
          <Tab className="user__single__tab mll">Cyber Security</Tab>
        </TabList>
        <TabPanel>
          <ProductPageSubtitlesTabContent />
        </TabPanel>
        <TabPanel>
          <SdrPageSubtitlesTabContent />
        </TabPanel>
        <TabPanel>
          <CyberSecuritySubTitlesTabContent />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ProductPageSubtitlesTab;
